export { UWRequirementsExpandTable } from './uw-requirements-expand-table.component';
export * from './uw-requirements-expand-table.component';